var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundingSourceOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6fd231;stroke:#707070;opacity:0;}.b{fill:#fe7070;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(337.383 308)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.648,2.344A10.991,10.991,0,0,1,69.533.493L68.942.1a.586.586,0,0,0-.65,0L67.7.493a10.99,10.99,0,0,1-6.116,1.852A.586.586,0,0,0,61,2.93V9.62a10.91,10.91,0,0,0,7.432,10.35.586.586,0,0,0,.371,0A10.91,10.91,0,0,0,76.234,9.62V2.93A.586.586,0,0,0,75.648,2.344ZM75.063,9.62a9.713,9.713,0,0,1-6.445,9.175A9.713,9.713,0,0,1,62.172,9.62V3.5a12.154,12.154,0,0,0,6.18-2.035l.265-.177.265.177A12.154,12.154,0,0,0,75.063,3.5Z",
    transform: "translate(-61 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M212.172,211.586v.586h-.586a.586.586,0,0,0,0,1.172h.586v.586a.586.586,0,1,0,1.172,0v-.586h.586a.586.586,0,1,0,0-1.172h-.586v-.586a.586.586,0,0,0-1.172,0Z",
    transform: "translate(-205.141 -202.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M151,155.1a4.1,4.1,0,1,0,4.1-4.1A4.106,4.106,0,0,0,151,155.1Zm7.031,0a2.93,2.93,0,1,1-2.93-2.93A2.933,2.933,0,0,1,158.031,155.1Z",
    transform: "translate(-147.484 -145.102)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingSourceOutline);
export default __webpack_public_path__ + "static/media/fundingSourceOutline.5fcfd5c930717675946377e13de69bff.svg";
export { ForwardRef as ReactComponent };